import { Injectable, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Store } from "@ngrx/store";

import { selectSelectedCompanyId } from "src/app/store/user/user.selectors";

/**
 * Single source for company-scoped navigation links. Centralizes the
 * `["/", companyId, ...segments]` construction that used to be copied as a
 * `baseRoute` helper in every side-nav view.
 */
@Injectable({ providedIn: "root" })
export class NavRoutesService {
    private readonly store = inject(Store);

    /** Selected company id, or null before the user store is hydrated. */
    public readonly companyId = toSignal(
        this.store.select(selectSelectedCompanyId),
        { initialValue: null },
    );

    /**
     * Build a company-scoped router link. Returns `["/"]` until a company is
     * selected so links stay valid during bootstrap.
     */
    public route(...segments: (string | number)[]): string[] {
        const id = this.companyId();
        return id ? ["/", String(id), ...segments.map(String)] : ["/"];
    }
}
